export default {
  black: '#000',
  grayDark: '#333',
  gray: '#707070',
  grayLight: '#ccc',
  white: '#fff',
  brandPurple: '#ac56ef',
}
